/**
 * Created by sagil on 09/10/2016.
 */
import {Component, EventEmitter, Input, Output} from "@angular/core";

@Component({
	selector: 'cp-error-popup',
	template: `
	<cp-info-popup [messagesHeightChanges]="messagesHeightChanges"  [level]="'Error'" (close)="close.emit($event)">
		<ng-content select=".popup-text" ngProjectAs=".popup-text"></ng-content>
		<ng-content select=".popup-buttons" ngProjectAs=".popup-buttons"></ng-content>
	</cp-info-popup>`
})
export class ErrorPopupComponent {
	@Output() close = new EventEmitter();
	@Input() messagesHeightChanges;
}
